"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sasso-marconi": {
    "7c976574": [{
      "hkey": "476b18a1",
      "slug": "battedizzo",
      "name": "Battedizzo",
      "primary": true,
      "skipSearch": false
    }],
    "badolo-battedizzo": [{
      "hkey": "476b18a1",
      "slug": "battedizzo",
      "name": "Battedizzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "83aed44f": [{
      "hkey": "becaa864",
      "slug": "borgonuovo-pontecchio-marconi",
      "name": "Borgonuovo-Pontecchio Marconi",
      "primary": true,
      "skipSearch": false
    }],
    "borgonuovo": [{
      "hkey": "becaa864",
      "slug": "borgonuovo-pontecchio-marconi",
      "name": "Borgonuovo-Pontecchio Marconi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "dc2eabd3": [{
      "hkey": "fb34d86c",
      "slug": "sasso-marconi",
      "name": "Sasso Marconi",
      "primary": true,
      "skipSearch": false
    }],
    "pieve-del-pino": [{
      "hkey": "fb34d86c",
      "slug": "sasso-marconi",
      "name": "Sasso Marconi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0b3b68b4": [{
      "hkey": "becaa864",
      "slug": "borgonuovo-pontecchio-marconi",
      "name": "Borgonuovo-Pontecchio Marconi",
      "primary": true,
      "skipSearch": false
    }],
    "pontecchio-marconi": [{
      "hkey": "becaa864",
      "slug": "borgonuovo-pontecchio-marconi",
      "name": "Borgonuovo-Pontecchio Marconi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "sasso-marconi"
    }]
  }
};
exports["default"] = _default;